export const theme = {
    backgroundColor: "#F8F8FC",
    borderColor: "#d2d1d1"
};